import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_FULFILLMENT_SETTINGS = `${URL_RETAILER_SCOPED}/fulfillment-settings`
const URL_FULFILLMENT_SETTINGS_FULFILLMENT_CONFIGURATIONS = `${URL_FULFILLMENT_SETTINGS}/fulfillment-configurations`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'fulfillment-settings'>
  | DashRouteType<'fulfillment-settings-fulfillment-configurations'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'fulfillment-settings': URL_FULFILLMENT_SETTINGS,
  'fulfillment-settings-fulfillment-configurations':
    URL_FULFILLMENT_SETTINGS_FULFILLMENT_CONFIGURATIONS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
